import { Controller } from '@hotwired/stimulus'
import { useIntersection } from 'stimulus-use'
import { wrapViewTransition } from '../helpers/view_transitions'

export default class extends Controller {
  static targets = ['dialog']
  static values = {
    redirectToOnClose: { type: String, default: null },
    modal: { type: Boolean, default: true }
  }

  connect () {
    this.element.dispatchEvent(new CustomEvent('connect'))
    useIntersection(this)

    document.addEventListener('turbo:before-cache', this.closeAllDialogs)
  }

  disconnect () {
    document.removeEventListener('turbo:before-cache', this.closeAllDialogs)
  }

  open () {
    this.closeAllDialogs()
    if (this.modalValue) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.show()
    }
  }

  close () {
    wrapViewTransition(() => {
      this.dialogTarget.close()
      if (this.redirectToOnCloseValue) {
        window.Turbo.visit(this.redirectToOnCloseValue, { action: 'replace' })
      }
    })
  }

  closeAllDialogs () {
    document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close())
  }
}
